export const searchThemesFromTechnology = {
    description:
        'You can find themes that match the content of the technology you want to analyze. You can check the details from the theme name.',
    filterThemeLabel: 'Filter themes',
    filterThemePlaceholder: 'Please enter a keyword',
    filterThemeExample: 'Example input: ammonia, chemical fibers, etc.',
    searchTarget: 'Search target',
    clusterName: 'Cluster Name',
    ipcLabel: 'Technology classification (IPC) label',
    publicationNumber: 'Publication Number',
    searchOption: 'Filter options',
    ipcCodeLabel: 'Technology classification (IPC) code',
    ipcCodePlaceholder: 'Please enter a keyword',
    searchButton: 'Filter',
    themeList: 'Theme List',
    sortDescription: '※ You can sort a single column by clicking its header.',
    countText: 'Matched Themes :',
    countUnit: '', // English doesn't use classifiers, so they're omitted.

    // テーマ一覧のカラム
    category: 'Category',
    theme: 'Theme Name',
    numberOfClusterName: 'Number of matches for cluster name',
    numberOfIpcLabel: 'Number of matches for technology classification (IPC) label',
    numberOfIpcCode: 'Number of matches for technology classification (IPC) code',
    numberOfPatent: 'Number of matches for Patent Applications',

    unSearched: '※ When filtering themes by keyword, search results will be displayed',
    analyzedThemeButton: 'Analyze the selected theme'
}
